export const BASE_URL = process.env.REACT_APP_API_URL;

export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

export const COMPLETIONS_URL = process.env.REACT_APP_COMPLETIONS_IMAGE_URL;

export const APPSTORE_LINK = process.env.REACT_APP_APPSTORE_LINK;

export const PLAYSTORE_LINK = process.env.REACT_APP_PLAYSTORE_LINK;

export const RECAPCHA_SITE_KEY = process.env.REACT_APP_SITE_KEY;

export const RECAPCHA_ENABLED = process.env.NODE_ENV === "production";
